<template>
  <div class="legal" v-html="terms"></div>
</template>

<script>

import VueElementLoading from "vue-element-loading";

export default {
  components: {
    VueElementLoading,
  },
  data() {
    return {
      isLoading: false,
      terms: null,
    };
  },
  mounted() {
    this.getTerms();
  },
  methods: {
    getTerms() {
      this.isLoading = true;
      axios
        .get("/docs/terms")
        .then((response) => {
          this.isLoading = false;
          this.terms = response.data.terms;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notify({
            title: "Error",
            text: this.$t("error_retrieving_terms"),
            type: "error",
          });
        });
    },
  },
};
</script>
<style scoped>
.legal {
  width: min(800px, calc(100% - 32px));
  margin: 0 auto;
  padding: 48px 0 80px;
}
</style>
